module.exports = __webpack_public_path__ + "static/media/girl_pointing_ring.e40c89d5.gif";